import { createEnv } from "@t3-oss/env-core";
import { z } from "zod";

/**
 * Environment configuration for UI (Vite) applications
 * Uses @t3-oss/env-core with clientPrefix for client-side validation
 */
export const env = createEnv({
  /**
   * The prefix that client-side variables must have in Vite.
   * This is enforced both at a type-level and at runtime.
   */
  clientPrefix: "VITE_",

  /**
   * Specify your client-side environment variables schema here.
   * These variables are exposed to the client.
   */
  client: {
    VITE_API_URL: z.string().url().default("http://localhost:3000"),
    VITE_BASE_PATH: z.string().default("/").optional(),
    VITE_MERCADO_PAGO_PUBLIC_KEY: z.string().default(""),
    // Mirrors PAYMENT_PROVIDER in ./api.ts — defaults to the provider the
    // product actually uses, not the untested template one. The assertion below
    // therefore now bites on a default install: a mercadopago UI needs
    // VITE_MERCADO_PAGO_PUBLIC_KEY to render a checkout at all.
    VITE_PAYMENT_PROVIDER: z.enum(["polar", "mercadopago"]).default("mercadopago"),
    VITE_SUBSCRIPTION_MODE: z.enum(["user", "organization"]).default("organization"),
    VITE_SUDO_EMAILS: z.string().default(""),
    // Mapcn tile/style URL — required for any map rendering (address picker, rider map, customer tracking)
    VITE_MAPCN_TILES_URL: z.string().default(""),
    // VAPID public key — needed by the rider PWA to subscribe to Web Push
    VITE_VAPID_PUBLIC_KEY: z.string().default(""),
  },

  /**
   * What object holds the environment variables at runtime.
   * For Vite, this is `import.meta.env`.
   */
  runtimeEnv: import.meta.env,

  /**
   * Makes it so empty strings are treated as undefined.
   * `SOME_VAR: z.string()` and `SOME_VAR=''` will throw an error.
   */
  emptyStringAsUndefined: true,
});

if (env.VITE_PAYMENT_PROVIDER === "mercadopago" && !env.VITE_MERCADO_PAGO_PUBLIC_KEY) {
  throw new Error(
    'Missing required environment variable "VITE_MERCADO_PAGO_PUBLIC_KEY" for PAYMENT_PROVIDER=mercadopago',
  );
}
